import { Packages } from '../web-shared/types/billing';

export enum ExternalURL {
  HELP = 'https://help.philo.com/using-philo/download',
}

export const EXPERIMENT_SET = [Packages.PHILO_PLUS];

export const PRODUCT_NAME = 'Philo';

export const DEFAULT_PRODUCT_IMAGE_URL = '/storage/images/try/tv-image-nav.png';
export const PHILO_LOGO_IMAGE_URL = '/storage/images/philo-opengraph.png';

export const SRC_TV_FRAME_GRAY = '/storage/images/try/tv-frame-gray.png';
export const SRC_TV_REMOTE_GRAY = '/storage/images/try/tv-remote-gray.png';

export const TV_PRODUCT_BG = '/storage/images/try/tv.png';

export const EXPERIMENT_CHANNEL_LINEUP = 'channelLineup2021-09-15';

export enum Experiment {
  AUTO_ADD_ON = 'autoAddOn2024-09-19',
  FAST_CHANNEL_EXPERIMENT = 'fastChannelWelcomePage2024-02-28',
  FAST_UNCREDENTIALED_LANDING_PAGE_EXPERIMENT = 'fastUncredentialedLandingPage2024-09-06',
  LANDING_PAGE_ADD_ON = 'landingPageAddOn2023-08-30',
  LANDING_PAGE_EVENT_BANNER = 'landingPageEventBanner2023-12-06',
  MOVE_WELCOME_REDEMPTION_CODE = 'moveWelcomeRedemptionCode2024-06-21',
  MULTI_MONTH_OFFER = 'multimonthOffer2023-07-31',
  MULTI_MONTH_SIGNUP = 'multimonthSignup2023-07-31',
  ONBOARDING_HELP = 'onboardingHelpv22023-02-10',
  POSTER_MODALS = 'landingPagePosterModals2022-12-19',
  SCALE_STICKY_HEADER = 'scaleStickyHeader2022-06-02',
  SHOW_PAGE_CHANNEL_CLICKABLE = 'showPageChannelClickable2023-08-22',
  SHOW_PAGE_EPISODES = 'showPageEpisodesOnTop2023-04-11',
  SHOW_PAGE_NEW_FAQ = 'showPageNewFaq2023-04-06',
  SHOW_PAGE_REDESIGN_EPISODES = 'showPageRedesignEpisodes2024-02-22',
  SIGNUP_VALUE_PROPS = 'signUpValueProps2024-03-04',
  SITELINKS_NAVBAR = 'sitelinksNavbar2022-04-21',
  SWAP_BILLING_ITEMS = 'swapBillingItems2024-05-20',
  VS_CABLE = 'landingPagePhiloCable2023-04-10',
  WELCOME_HERO = 'welcomeHero2024-04-11',
  WELCOME_FAST_CTA = 'welcomeFastCta2024-07-26',
}

export enum Variant {
  CONTROL = 'control',
  DARK = 'dark_color',
  EXCLUDED = 'excluded',
  HEADLINE = 'headline',
  LIGHT = 'light_dark',
  TREATMENT = 'treatment',
  TREATMENT_V1 = 'treatment_v1',
  TREATMENT_V2 = 'treatment_v2',
  TREATMENT_V3 = 'treatment_v3',
  TREATMENT_V4 = 'treatment_v4',
}
